<template>
    <el-row class="btnGroups">
        <el-col class="btnBox" :span="6">
            <template v-for="(item, index) in btnMapData[currentBtnType]">
                <div :class="{ btn: 1, disableBtn: !hasVehicleData(item.deviceType) }" :key="index" @click="switchType(item.val, hasVehicleData(item.deviceType))">{{ item.label }}</div>
            </template>
        </el-col>
    </el-row>
</template>
<script>
export default {
    props: {
        currentBtnType: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            btnMapData: {
                0: [
                    {
                        label: 'OBD',
                        val: 1,
                        deviceType: 0
                    },
                    {
                        label: '双摄',
                        val: 2,
                        deviceType: 1
                    },
                    {
                        label: '单摄',
                        val: 3,
                        deviceType: 2
                    }
                ],
                1: [
                    {
                        label: '主屏',
                        val: 0,
                        deviceType: 999
                    },
                    {
                        label: '双摄',
                        val: 2,
                        deviceType: 1
                    },
                    {
                        label: '单摄',
                        val: 3,
                        deviceType: 2
                    }
                ],
                2: [
                    {
                        label: '主屏',
                        val: 0,
                        deviceType: 999
                    },
                    {
                        label: 'OBD',
                        val: 1,
                        deviceType: 0
                    },
                    {
                        label: '单摄',
                        val: 3,
                        deviceType: 2
                    }
                ],
                3: [
                    {
                        label: '主屏',
                        val: 0,
                        deviceType: 999
                    },
                    {
                        label: 'OBD',
                        val: 1,
                        deviceType: 0
                    },
                    {
                        label: '双摄',
                        val: 2,
                        deviceType: 1
                    }
                ]
            },
            deviceTypeAnalysis: [
                {
                    deviceType: 0,
                    vehicleNum: null,
                    totalMileage: null,
                    totalDrivingDuration: null
                },
                {
                    deviceType: 1,
                    vehicleNum: null,
                    totalMileage: null,
                    totalDrivingDuration: null
                },
                {
                    deviceType: 2,
                    vehicleNum: null,
                    totalMileage: null,
                    totalDrivingDuration: null
                }
            ],
            deviceTypeObj: {
                999: { label: '大屏', vehicleNum: 999 }
            }
        };
    },
    mounted() {
        this.getDeviceTypeAnalysis();
    },
    methods: {
        hasVehicleData(deviceType) {
            const currentItem = this.deviceTypeObj[deviceType];
            return !!(currentItem && currentItem.vehicleNum > 0);
        },
        switchType(type, hrefFlag) {
            if (!hrefFlag) return;
            this.$emit('switchType', type);
        },
        // 设备总览
        getDeviceTypeAnalysis() {
            this.$request({
                method: 'post',
                url: '/report/api/iovLargeScreen/deviceTypeAnalysis',
                data: {}
            }).then((res) => {
                if (res.code == 200) {
                    // 执行处理
                    const processedData = this.processData(res.data);
                    this.deviceTypeAnalysis = processedData;
                    this.deviceTypeObj = {
                        999: { label: '大屏', vehicleNum: 999 }
                    };
                    processedData.forEach((item) => {
                        this.deviceTypeObj[item.deviceType] = item;
                    });
                }
            });
        },
        // 处理数据的函数
        processData(arr) {
            return arr.map((item) => {
                // 复制原对象避免直接修改
                const newItem = { ...item };

                // 遍历所有字段
                for (const key in newItem) {
                    if (!newItem[key]) {
                        newItem[key] = 0;
                    }
                    // 跳过vehicleNum字段
                    if (key == 'totalDrivingDuration') {
                        // 处理有值的数字字段（排除null/undefined）
                        if (newItem[key] !== null && newItem[key] !== undefined && typeof newItem[key] === 'number') {
                            if (newItem[key] >= 10000) {
                                newItem['tmpStr'] = Math.round(newItem[key] / 10000);
                            }
                        }
                    }
                }

                return newItem;
            });
        }
    },
    watch: {
        currentBtnType: {
            handler(val) {},
            immediate: true
        }
    }
};
</script>
<style lang="less" scoped>
.btnGroups {
    .btnBox {
        display: flex;
        // justify-content: space-around;
        position: absolute;
        left: 0.5rem;
        top: 0.45rem;
        z-index: 9;
        .btn,
        .disableBtn {
            width: 1.34rem;
            height: 0.35rem;
            line-height: 0.35rem;
            text-align: center;
            cursor: pointer;
            font-family: YouSheBiaoTiHei;
            font-size: 0.18rem;
            margin-left: 0.32rem;
            color: #daedff;
            background: url(../../../public/images/home/btnBgc0.png) no-repeat;
            background-size: 100% 100%;
        }
        .btn:first-child {
            margin-left: 0;
        }
        .btn:hover {
            background: url(../../../public/images/home/btnBgc1.png) no-repeat;
            background-size: 100% 100%;
        }

        .disableBtn {
            cursor: not-allowed;
            opacity: 0.5;
        }
        .disableBtn:hover {
            background: url(../../../public/images/home/btnBgc0.png) no-repeat !important;
            background-size: 100% 100% !important;
        }
    }
}
</style>
